import { IMetaState, EMetaStatus } from '../../../types/filters';

export const defaultState: IMetaState = {
  status: EMetaStatus.Initial,
  url: '',
  mapUrl: '',
  count: 0,
};
